<template>
    <div data-component-name="no-cards" class="no-cards">
        <div class="grid-container">
            <!-- Cards -->
            <template>
                <!-- Add additional cards placeholder -->
                <div class="add-cards">
                    <div class="dotted-line">
                        <span class="lt-CreditCards lg-icon"></span>
                        <p>Use the search bar to add cards to compare.</p>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<style src="../../shared/sass/saved-cards/no-cards.scss" lang="scss"></style>
<script>
    export default {
        name: "no-cards",
        methods: {
            removeCard: function (index) {
                var cardIdValue = this.cards[index].cardId;
                var savedCreditCards = localStorage.getItem('cardItems') ? JSON.parse(localStorage.getItem('cardItems')) : [];
                var indexOfSession = savedCreditCards.findIndex(card => card.cardId == cardIdValue);
                if (indexOfSession != -1) {
                    savedCreditCards.splice(indexOfSession, 1);
                    localStorage.setItem('cardItems', JSON.stringify(savedCreditCards));
                }
                this.cards.splice(index, 1);
            },
            trackCTA: function (index, buttonText, eventName) {
                var card = this.cards[index];
                var position = ++index;
                var category = this.$analyticsService.getCategoryName();

                var clickoutID = this.pageRequestId + '-' + card.legacyId + '-' + position;
                var trackData = { clickoutid: clickoutID, creditCard_data: [], cta_clicked: buttonText };
                var trackCard = {
                    card_bt_passback: card.bankTermPassback,
                    card_id: card.cardId,
                    card_page: location.href,
                    card_position: position,
                    card_section: category,
                    category: category,
                };
                trackData.creditCard_data.push(trackCard);
                this.$analyticsService.trackCTA(trackData, eventName);
            },
            getRewardsVal: function (value) {
                return value ? value : 'N/A';
            },
            getFeeVal: function (value) {
                return value ? value : 'See Terms';
            }
        },
        data: function () {
            return {
                credit: false,
                type: false,
                offers: false,
                info: false,
                fees: false,
                details: false,
            }
        },
    }
</script>
